module.exports = __webpack_public_path__ + "img/9-11_conacin_franco_cabello.731efda2.jpg";